up.compiler('[invoice-item-calc]', (element) => {
  const quantityInput = element.querySelector('[id$="_quantity"]')
  const valueInput = element.querySelector('[id$="_value"]')
  const discountInput = element.querySelector('[id$="_discount"]')
  const discountTypeSelect = element.querySelector('[id$="_discount_type"]')
  const taxRateInput = element.querySelector('[id$="_tax_rate"]')
  const totalDisplay = element.querySelector('[invoice-item-total]')
  const totalWithTaxDisplay = element.querySelector('[invoice-item-total-with-tax]')

  if (!quantityInput || !valueInput || !totalDisplay) return

  function parseGermanNumber(str) {
    if (!str || str.trim() === '') return 0
    return parseFloat(str.replace(',', '.')) || 0
  }

  function formatMoney(num) {
    return num.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €'
  }

  function calculate() {
    const quantity = parseGermanNumber(quantityInput.value)
    const unitPrice = parseGermanNumber(valueInput.value)
    const discount = discountInput ? parseGermanNumber(discountInput.value) : 0
    const discountType = discountTypeSelect ? discountTypeSelect.value : 'absolute'
    const taxRate = taxRateInput ? parseGermanNumber(taxRateInput.value) : 0

    const subtotal = unitPrice * quantity

    let discountValue = 0
    if (discount !== 0) {
      discountValue = discountType === 'percentage' ? subtotal * discount / 100 : discount
    }

    const total = subtotal - discountValue
    totalDisplay.textContent = formatMoney(total)

    if (totalWithTaxDisplay && taxRate > 0) {
      const totalWithTax = total + (total * taxRate / 100)
      totalWithTaxDisplay.textContent = 'mit Steuer: ' + formatMoney(totalWithTax)
    }
  }

  const inputs = [quantityInput, valueInput, discountInput, taxRateInput].filter(Boolean)
  inputs.forEach(input => input.addEventListener('input', calculate))

  // discount_type is a select — listen for change
  if (discountTypeSelect) {
    discountTypeSelect.addEventListener('change', calculate)
  }
})
